// TODO: Refactor: Split events / functions (again)!!!

// Triggers stuff when the (x)HTML is done loading ...
// INFO: https://www.w3schools.com/jquery/event_ready.asp
the_doc.ready( function() {
	// Check for jQuery
	check_jQuery();

	// Fix passive listeners
	set_listener_fix();

	// Check for touch screen
	check_touch();

	// Set the language data set
	set_lang_data_set();

	// Init cart contents stats
	do_process_cart();

	// Trigger slick sliders
	// If slider present unset drag events on slicked child nodes
	jQuery( set_slicked() ).promise().done( function() {
		set_no_drag();
	});

	// Set lazy load
	// set_lazy_load();

	// Set select2
	set_select2();

	// Trigger lightbox
	set_lightbox();

	// Trigger datepicker
	set_datepicker();

	// Set the correct listing view
	// TODO: Check this
	if ( ! body_class( 'is_watch_list' ) ) {
		set_list_view( list_view );
	} else {
		setTimeout( function() {
			set_list_view( '1' );
		}, 250 );
	}

	// Init 360 slider
	if ( threesixty === true ) {
		check_360_slider();
	}
	if ( trigger_attribute_filter_event === true ) {
		trigger_attribute_filter();
	}
	if ( body_class( 'is_detail' ) ) {
		let select_component_amount_found = jQuery('.js_select_component_amount');
		if (typeof select_component_amount_found !== 'undefined' && select_component_amount_found.length > 0) {
			check_package_selected_items_amount(select_component_amount_found, true);
			init_configurable_set_text();
		}
	}
	if ( body_class( 'is_checkout_express' ) ) {
		trigger_shipping_change();
	}
	if ( body_class( 'is_list_categories' ) || body_class( 'is_list_products' ) ) {
		trigger_menu_hover_change();
	}

	if ( body_class( 'is_list_products' ) && (getUrlParameter( 'filter_by' ) || getUrlParameter( 'search_filter' )) ) {
		check_existing_filters(getUrlParameter( 'search_filter' ));
	}

	// If form is b2b disable b2c form elements
	let b2b_form_active = jQuery('.form_b2b.active');
	if (b2b_form_active.length > 0) {
		jQuery('.js_b2c_element input').prop("disabled", true);
		jQuery('.js_b2c_element select').prop("disabled", true);
	}

	// If form is b2c disable b2b form elements
	let b2c_form_active = jQuery('.form_b2c.active');
	if (b2c_form_active.length > 0) {
		jQuery('.js_b2b_element input').prop("disabled", true);
		jQuery('.js_b2b_element select').prop("disabled", true);
	}


	// trigger country required when form is loaded
	let this_selected	= jQuery( 'select.country_id option:selected' );
	if(typeof this_selected !== 'undefined' && this_selected.length){
		let this_id         = this_selected.val();
		check_country_required(this_id);
	}


	// set action countdown
	get_action_countdown();

	// trigger search by selected category
	if ( body_class( 'is_adv_search' ) && getUrlParameter( 'search_category' ) && getUrlParameter( 'search_category' ) != '0' ) {
		populate_product_list( 'split_page_search', 1, getUrlParameter( 'search_category' ) );
	}

	// Load watchlist counter
	do_watchlist();
});

// --------------------

// Triggers stuff when EVERYTHING has finished loading ...
the_win.on( 'load', function( e ) {
	// Load article price(s) dynamically
	ajax_load_list_prices_detailed( 'js_get_list_price' );
});

// --------------------

// Triggers stuff when scrolling ...
// INFO: https://www.w3schools.com/jquery/event_scroll.asp
the_win.on( 'scroll', function( e ) {
	// Set scroll
	set_scroll();
});

// --------------------

/*
// Serve images instead of video when lower speed than 4G
// INFO: https://web.dev/optimize-lcp/?utm_source=lighthouse&utm_medium=devtools#preload-important-resources
if ( navigator.connection && navigator.connection.effectiveType ) {
	if ( navigator.connection.effectiveType === '4g' ) {
		// Do something...
	} else {
		// Do something else...
	}
}
*/

// --------------------

/*
// Triggers stuff when window is being resized ...
// INFO: https://www.w3schools.com/jquery/event_resize.asp
the_win.on( 'resize', function( e ){
	// Do something...
});
*/

// --------------------

// TODO: What is this for? - bubbling
the_doc.on( 'keyup', function( e ) {
	e.preventDefault();

	// Key bindings
	let key = 'which' in e ? e.which : e.keyCode;

	// When ENTER is pressed
	if ( key == 13 ) {
		if ( jQuery( '#message' ).is( ':visible' ) == true ) {
			close_message();
			mask_layer( false );
		}
	}
});

// --------------------

// Tooltip fix for touchscreens
// TODO: Can we solve this differently?
the_doc.on( 'tap touchend', function() {
	// Hide tooltip
	tooltip_cloud();
});

// --------------------

// Listing actions
// Switch listing view (tiles / list)
the_doc.on( 'click', '.js_list_view', function( e ) {
	set_list_view( '', jQuery( this ) );
});

// ----------------------------

// Trigger loader when AJAX'ing
the_doc.ajaxStart( function() {
	// Show loader
	loading( true );
});

// Stop loader when AJAX'ing is done
the_doc.ajaxComplete( function() {
	// Hide loader
	loading( false );
});

// ----------------------------

// Trigger lightbox externally

// First prevent default trigger
the_doc.on( 'click tap', '.img_zoom', function( e ) {
	e.preventDefault();
	e.stopPropagation();
	return false;
});

the_doc.on( 'click', '.product_zoom', function( e ) {
	e.preventDefault();
	e.stopPropagation();

	let img_parent	= jQuery( this ).parent().parent();
	let has_slick		= img_parent.find( '.js_slicked.slide' ).length;

	// Has slick
	if ( has_slick ) {
		img_parent.find( '.slick-current.slick-active img' ).trigger( 'click' );
		// Default
	} else {
		img_parent.find( '.product_img img' ).trigger( 'click' );
	}
});

// ----------------------------

// Toggle input password visibility
the_doc.on( 'click', '.js_toggle_password', function( e ) {
	let target_input = jQuery( this ).closest( '.password_wrapper' ).find( 'input' );

	jQuery( this ).toggleClass( 'is_visible' );
	target_input.attr( 'type' ) === 'password' ? target_input.attr( 'type', 'text' ) : target_input.attr( 'type', 'password' );
});

// ----------------------------

// Form validation - On form submit
the_doc.on( 'submit', 'form', function( e ) {
	check_fields( jQuery( this ), e );
});

// Form validation - On field blur
the_doc.on( 'blur', '.js_required:visible', function( e ) {
	check_fields( jQuery( this ), e );
});

// Form validation - On select2 change
// the_doc.on( 'blur', '.select2-container--focus', function( e ) {
// the_doc.on( 'blur', '.select + select.js_required', function( e ) {
// 	let _this			= jQuery( this );
// 	let this_form		= _this.closest( 'form' );
// 	let this_container	= _this.closest( '.select' );
// 	let this_select 	= this_container.find( 'select.js_required' );
// 	let this_name 		= this_select.attr( 'name' );
// 	// Debug ...
// 	console.log( 'this: ' + _this );
// 	// console.log( 'this_form: ' + this_form.length );
// 	// console.log( 'this_container: ' + this_container.length );
// 	// console.log( 'this_select: ' + this_select.length );
// 	console.log( 'this_name: ' + this_name );
// 	// Only trigger this (hacky solution) if the select is required
// 	// if ( this_select.length === 1 ) {
// 		setTimeout( function() {
// 			// check_fields( jQuery( 'select[name="' + this_name + '"]' ), e );
// 			check_fields( _this, e );
// 		}, 250 );
// 	// }
// });

// ----------------------------

// Remove all AJAX filters
the_doc.on( 'click', '.js_remove_all_filters', function( e ) {
	e.preventDefault();
	// Hide tooltip
	tooltip_cloud();
	let cur_cat_id = jQuery( '.ajax_product_listing' ).attr( 'data-catId' );
	let ajax_function = 'reset_filter';
	let searched_keywords = '';
	if( original_curr_page === 'advanced_search_result'){
		ajax_function = 'split_page_search';
		searched_keywords =  jQuery( '.js_searched_keywords' ).attr( 'data-keywords' );
		cur_cat_id = jQuery( '#main_listing' ).attr( 'data-catid' );
	}else{
		jQuery( '.select_filter' ).val( '' ).change();
		let cur_cat_url = jQuery( '.ajax_product_listing' ).attr( 'data-url' );
		change_url_state(cur_cat_url );
	}

	jQuery.ajax({
		type: 'post',
		url: ajax_url_global + Math.random(),
		data: {
			cat_id: cur_cat_id,
			keywords: searched_keywords,
			ajax_action: 'product_listing',
			function: ajax_function
		},
		async: true,
		dataType: 'json',
		success: function( data ) {
			jQuery( '.ajax_filter_reset_block' ).html( '' );
			populate_product_list_content( data.list );
			if( original_curr_page === 'advanced_search_result'){
				jQuery('.js_search_filters_wrapper ').html(data.filter_search_element);
				set_select2();
			}
		}
	});
});

// Remove all variant filters
the_doc.on( 'click', '.js_remove_all_variant_filters', function( e ) {
	jQuery( 'select.select_variant' ).val( '' ).change();
	jQuery( '.js_remove_all_variant_filters' ).hide();
	return false;
});

// ----------------------------

// Objektleiter - Login as.. Dropdown for user logged in
the_doc.on( 'change', '.js_select_objektleiter', function( e ) {
	jQuery( '#customer_select_form' ).submit();
});

// ----------------------------

// Goto url
the_doc.on( 'click', '.js_link', function( e ) {
	e.preventDefault();
	let url		= jQuery( this ).data( 'url' );
	let target	= jQuery( this ).data( 'target' ); // data-target="_blank" === new tab
	go_navigate( e, url, true, target );
});

// ----------------------------

// Global dynamic open
the_doc.on( 'click', '.js_open', function( e ) {
	e.stopPropagation();
	let _this			= jQuery( this );
	let target_wrapper	= _this.parent().find( '.js_close_wrapper' );

	target_wrapper.addClass( 'active' );
});

// Global dynamic close
the_doc.on( 'click', '.js_close', function( e ) {
	e.stopPropagation();
	let _this			= jQuery( this );
	let target_wrapper	= _this.closest( '.js_close_wrapper' );
	let target_checkbox	= _this.closest( '.js_open' ).parent().find( '.js_checkbox_ref' );
	let has_checkbox	= target_checkbox.length;

	if ( target_wrapper.hasClass( 'active' ) === true ) {
		target_wrapper.removeClass( 'active' );

		if ( has_checkbox && typeof has_checkbox !== 'undefined' ) {
			target_checkbox.prop( 'checked', false );
		}
	}
});

// ----------------------------

// Change currency
the_doc.on( 'click', '.js_change_currency', function( e ) {
	e.preventDefault();
	change_currency( e, jQuery( this ), CURRENCY_CHANGE_POPUP );
});

// ----------------------------

// Scroll to top
the_doc.on( 'click', '.js_scroll_top', function( e ) {
	e.preventDefault();
	// e.stopPropagation();
	scroll_to_top();
});

// ----------------------------

// Pagination - Go to page
the_doc.on( 'click', '.js_go_page', function( e ) {
	let cur_page = jQuery( '.ajax_product_listing' ).attr( 'data-page' );

	// TODO: Migrate to use bodyclass function
	if ( cur_page !== 'account_history') {
		e.preventDefault();
		let _this	= jQuery( this );
		let page	= _this.attr( 'data-page' );

		populate_product_list( 'split_page', page );
	}
});

// ----------------------------

// Render tooltip
the_doc.on({
	mousemove: function( e ) {
		clearTimeout( mouse_timer );
		let _this = jQuery( this );
		let this_text = _this.attr( 'data-tooltip' );
		jQuery( '#tooltip_cloud' ).attr( 'class', 'tooltip_cloud' );
		prep_tooltip( this_text );
		mouse_timer = setTimeout( render_tooltip( e, _this ), 30 );
	},
	touchstart: function( e ) {
		clearTimeout( mouse_timer );
		let _this = jQuery( this );
		let this_text = _this.attr( 'data-tooltip' );
		jQuery( '#tooltip_cloud' ).attr( 'class', 'tooltip_cloud' );
		prep_tooltip( this_text );
		mouse_timer = setTimeout( render_tooltip( e, _this ), 30 );
	},
	mouseleave: function() {
		jQuery( '#tooltip_cloud' ).attr( 'class', 'tooltip_cloud' );
		tooltip_cloud();
	}
}, '.tooltip' );

// ----------------------------

// Input value per plus / min buttons
// TODO: Add trigger element detection (input OR select)!
the_doc.on( 'click', '.js_quantity_click', function( e ) {
	e.preventDefault();
	do_check_quantity( e, jQuery( this ) );
});

// Input value per direct input
the_doc.on({
	keyup: function( e ) {
		e.preventDefault();
		do_check_amount( e, jQuery( this ) );
	},
	keydown: function( e ) {
		do_check_numeric( e );
	},
	change: function( e ) {
		e.preventDefault();
		do_check_amount( e, jQuery( this ) );
	},
	// focus: function( e ) {
	// 	do_check_amount( e, jQuery( this ) );
	// },
	focusout: function( e ) {
		do_check_amount( e, jQuery( this ) );
	}
}, '.js_quantity_input' );

// Buy item / add to cart (modal)
the_doc.on( 'click', '.js_add_to_cart', function( e ) {
	e.preventDefault();
	// e.stopPropagation();
	add_to_cart( e, jQuery( this ) );
});

// Delete from cart (modal)
the_doc.on( 'click', '.js_delete_from_cart', function( e ) {
	e.preventDefault();
	// e.stopPropagation();
	delete_from_cart( e, jQuery( this ) );
});

// Flush cart
the_doc.on( 'click', '.js_empty_cart', function( e ) {
	e.preventDefault();
	empty_cart();
});

// Cart preview
the_doc.on( 'click', '.js_preview_cart', function( e ) {
	e.stopPropagation();
	let target_elem	= jQuery( '.cart_preview_wrapper' );
	target_elem.toggleClass( 'active' );
});

// Cart button click
the_doc.on( 'click', '.cart_button', function( e ) {
	let error	= false;
	let message	= '';

	if ( error === true ) {
		alert( message );
		return false;
	}
});

// ----------------------------

// Transfer cart per OCI
the_doc.on( 'click', '.js_transfer_oci_cart', function( e ) {
	e.preventDefault();

	if ( typeof hookurl === 'undefined' ) {
		// console.log("FATAL: no hook url");
		return false;
	}

	if ( typeof http_content_charset === 'undefined' ) {
		let http_content_charset = 'iso-8859-1';
	}

	let params = {
		'ajax_action' : 'shoppping_cart',
		'function' : 'getOCIdata'
	}

	jQuery.ajax({
		type: 'post',
		url: ajax_url_global + Math.random(),
		data: params,
		dataType : 'text',
		async: false,
		success: function( response ) {
			// Send cart data back to interface - response contains some <input> elements
			let inputs = response;
			// This forces form submission to use iso-8859-1 encoding in internet explorer
			document.charset = http_content_charset;

			let objFormular = jQuery( '<form action="' + hookurl + '" method="POST" accept-charset="' + http_content_charset + '">' + inputs + '</form>' );
			objFormular.appendTo( 'body' ).submit().remove();
			// Reset document encoding to utf-8
			document.charset = 'utf-8';

			// Empty exisiting shopping cart
			let data = 'ajax_action=shoppping_cart&function=delete_all';
			jQuery.post( ajax_url_global + Math.random(), data, null, 'json' );
		}
	});

	return false;
});

// ----------------------------

// LEGACY code - Add to cart
// TODO: check if we need anything from this + Remove this when switched to new markup!
// TODO: In the new event listeners and functions, also deal with dropdown values by detecting trigger element (input OR select)!
the_doc.on( 'click', '.js_to_cart ', function( e ) {
	// Prevent the default event from occurring
	e.preventDefault();
	// e.stopPropagation();
	// e.preventBubble = true;

	// The vars
	let _this			= jQuery( this );
	let this_id			= _this.data( 'id' );
	let unit_id			= _this.data( 'einheit_id' );
	let this_pos_id		= _this.data( 'pos_id' );
	let this_trigger	= _this.data( 'trigger' );
	let order_units		= _this.data( 'order_units' );
	let field_parent	= _this.parent().hasClass( 'no_wrapper' );
	let this_amount		= jQuery( 'select[id="input_' + this_id + '"]' );

	// Fallback for when there is no select used
	if ( this_amount.val() === undefined ) {
		this_amount = jQuery( 'input[id="input_' + this_id + '"]' );
	}

	let this_amount_val	= this_amount.val();

	// Add product
	// TODO: Check this - is it being used?
	if ( jQuery( '.account_history_info_table' ).length > 0 ) {
		this_amount_val = jQuery( '.account_history_info_table tbody .cell_select_qty .amount_product' ).val();
	}

	if ( ! field_parent ) {
		do_stuff( this_id, '', '', 'add_product', 'add', this_trigger,'','', unit_id );
	} else {
		do_stuff( this_id, '', this_amount_val, 'add_product', 'add', this_trigger,'','', unit_id );
		// Reset amount
		reset_amount();
	}

	// Reset input field amount
	function reset_amount() {
		if ( jQuery( '.js_variants' ).length > 0 ) {
			this_amount.val( '0' );
		} else {
			this_amount.val( '1' );
		}

		jQuery( 'select.amount_product' ).prop( 'selectedIndex', 0 );
		jQuery( 'select.amount_product' ).val( jQuery( 'select.amount_product option:first-child' ).val() ).trigger( 'change' );
	}
});

// ----------------------------

// Add varianten to cart
// LEGACY code, migrate to modern event / function!
the_doc.on( 'click', '.js_add_varianten, .js_check_partial_stock', function( e ) {
	e.preventDefault();
	let is_stock_partial_check	= jQuery( this ).hasClass( 'js_check_partial_stock' );

	let list_items = [];
	let total = 0;
	let ajax_function = 'add_multiple_products';

	if(!is_stock_partial_check){
		jQuery( '.js_variants input' ).each( function() {
			let _this		= jQuery( this );
			let this_id		= _this.data( 'prod_id' );
			let this_eid	= _this.data( 'used_unit_id' );
			let this_stock	= _this.data( 'stock' );
			if(_this.data( 'has_unit_ids' )){
				this_eid = _this.closest( '.product_quantity' ).find( 'select option:selected' ).data( 'unit_id' );
				this_stock	= _this.closest( '.product_quantity' ).find( 'select option:selected' ).attr( 'data-stock' );
			}
			let this_value	= _this.val();
			let this_min	= _this.data( 'min' );

			if ( parseInt( this_value ) > 0 ) {
				total++;
				list_items.push({ 'id': this_id, 'eid': this_eid, 'qty': this_value, 'min': this_min, 'stock' : this_stock });
			}
		});
	}else{
		ajax_function = 'check_stock';
	}


	if ( parseInt( total ) > 0 || is_stock_partial_check) {
		jQuery.ajax({
			type: 'POST',
			url: ajax_url_global + Math.random(),
			data: {
				ajax_action: 'shoppping_cart',
				function: ajax_function,
				var_content: JSON.stringify( list_items )
			},
			async: false,
			dataType: 'json',
			success: function( data ) {
				// TODO: Check if this is needed at all here???
				let added_to_cart_flag =  data.response_added_to_cart_flag;
				if(!is_stock_partial_check) {
					jQuery('.js_variants input').each(function () {
						let _that = jQuery(this);
						_that.val('0');
					});
					do_process_cart();
					//do_stuff( '', '', '', '', 'init_both', 'just_added' );
				}

				// TODO: Get HTML from PHP directly!
				if ( data.stock_check ) {
					// Get HTML form and set content
					let message = data.products_data;
					let showCancelButton = false;
					Swal.fire({
						customClass: {
							container: 'modal_large'
						},
						icon: 'warning',
						title: GLOB_ATTENTION,
						html: message,
						width: '80vw',
						focusConfirm: false,
						showDenyButton: showCancelButton,
						confirmButtonText: BTN_CONTINUE,
						denyButtonText: BTN_CANCEL,
						showCloseButton: true,
						preConfirm: () => {
							// Nested function to keep focus
							function do_grab_overbook_values() {
								// Checked radio
								let radio = jQuery( '.swal2-popup' ).find( 'input:checked' );
								// Grab all selected radio values
								radio.each( function( index, elem ) {
									let _this			= jQuery( this );
									let this_id			= _this.data( 'id' );
									let this_quantity	= _this.data( 'quantity' );
									let this_stock		= _this.data( 'stock' );
									let this_posid		= 0;
									if(is_stock_partial_check){
										this_posid		= _this.data( 'posid' );
									}

									let this_val		= _this.val();
									let this_amount		= '';

									if ( this_val === '1' ||  this_val === '2' ) {
										this_amount = this_quantity;
									} else {
										this_amount = this_stock;
									}

									modal_articles.push({
										product_id	: this_id,
										quantity	: this_amount,
										overbook	: this_val,
										posid	: this_posid,
									});
								});
							}

							jQuery( do_grab_overbook_values() ).promise().done( function() {
								do_process_overbook_list(is_stock_partial_check);
								// Empty array
								modal_articles = [];
							});
						}
					}).then(( result ) => {
						// Confirm
						if ( result.isConfirmed && added_to_cart_flag == '1') {
							// Show add to cart success toast
							toast_title     = GLOB_SUCCESS;
							toast_content   = CART_ADDED_SUCCESS;
							toast_icon      = 'success';

							do_toast( toast_title, toast_content, toast_icon, 3000, '', true );
							// Empty array
							modal_articles = [];
						}
					})
				}else if(is_stock_partial_check){
					go_navigate('', 'index.php?main_page=checkout_shipping');
				}
			},
			complete: function () { },
			error: function () {
				console.log( 'Something went wong... hai!' );
			}
		});
	}
});

// Select all of a specific overbook type in modal
the_doc.on( 'click', '.js_overbook_cell', function( e ) {
	let _this				= jQuery( this );
	let this_ref			= _this.attr( 'data-ref' );
	let target_inputs		= jQuery( '#swal2-content .overbook_cell .radio_container input' );
	let target_input_set	= jQuery( '#swal2-content .overbook_cell .radio_container input[data-val="' + this_ref + '"]' );

	target_inputs.prop( 'checked', false );
	target_input_set.prop( 'checked', true );
});

// ----------------------------

// CHECKOUT SHIPPING
the_doc.on( 'click', '#checkout_shipping, .js_checkout_confirmation_button ', function( e ) {
	e.preventDefault();
	let is_checkout_express	= jQuery( this ).hasClass( 'js_checkout_confirmation_button' );

	jQuery.ajax({
		type: 'POST',
		url: ajax_url_global + Math.random(),
		data: {
			ajax_action: 'general_settings',
			function: 'check_lieferschwelle',
		},
		async: true,
		success: function( data ) {
			let number_wrong_tax_rates = data.wrong_tax_rates.length;

			if ( number_wrong_tax_rates == 0 ) {
				if(is_checkout_express){
					jQuery( 'form[name="checkout_confirmation"]' ).submit();
				}else{
					jQuery( 'form[name="checkout_address"]' ).submit();
				}

			} else {
				if(is_checkout_express){
					jQuery( '.js_checkout_confirmation_button' ).trigger( 'ask_customer', [data] );
				}else{
					jQuery( '#checkout_shipping' ).trigger( 'ask_customer', [data] );
				}
			}
		}
	});
});

// Checkout page change AJAX comments
the_doc.on( 'change', '.js_ajax_comments', function( e ) {
	let comments = jQuery( this ).val();

	jQuery.ajax({
		type: 'post',
		url: ajax_url_global + Math.random(),
		data: {
			ajax_comments: comments,
			ajax_action: 'general_settings',
			function: 'save_comments'
		},
		async: true,
		success: function() {
			return true;
		}
	});
});

// ----------------------------

jQuery( '#checkout_shipping, .js_checkout_confirmation_button' ).on( 'ask_customer', function( e, response ) {
	// let title = GLOB_WARNING;
	// message( 'warning', title, response.message, 'jQuery("#checkout_shipping,.js_checkout_confirmation_button").trigger("delete_products", [\'' + response.trigger_parameter + '\'])', 'do_stuff( \'\', \'\', \'\', \'\', \'init_both\' )', false );

	Swal.fire({
		icon: 'warning',
		title: GLOB_WARNING,
		html: response.message,
		showDenyButton: true,
		confirmButtonText: BTN_CONTINUE,
		denyButtonText: BTN_CANCEL,
		showCloseButton: true
	}).then((result) => {
		if ( result.isConfirmed ) {
			jQuery( '#checkout_shipping,.js_checkout_confirmation_button' ).trigger( 'delete_products', response.trigger_parameter );
		} else {
			do_stuff( '', '', '', '', 'init_both' );
		}
	})
});

jQuery( '#checkout_shipping, .js_checkout_confirmation_button' ).on( 'delete_products', function( e, param1 ) {
	let is_checkout_express	= jQuery( this ).hasClass( 'js_checkout_confirmation_button' );
	jQuery.ajax({
		type: 'POST',
		url: ajax_url_global + Math.random(),
		data: {
			ajax_action: 'general_settings',
			function: 'remove_wrong_tax_rate_items',
			products: param1
		},
		success: function( data ) {
			if(is_checkout_express){
				go_navigate('', 'index.php?main_page=shopping_cart');
			}else{
				if ( data.products_in_cart === 0 ) {
					location.reload();
				} else {
					jQuery( 'form[name="checkout_address"]' ).submit();
				}
			}
		}
	});
});

// ----------------------------

// Global autocomplete
jQuery( '.js_autocomplete' ).on({
	keyup: function( e ) {
		e.preventDefault();
		let key = 'which' in e ? e.which : e.keyCode;
		// When ENTER is pressed
		if ( key === 10 || key === 13 ) {
			do_autocomplete_result( e, jQuery( this ), true );
		} else {
			clearTimeout(search_autocomplete_timeout);
			let this_element = jQuery( this );
			search_autocomplete_timeout = setTimeout(function() {
				do_autocomplete( e, 'open', this_element );
			}, 500);
		}
	},
	focus: function( e ) {
		e.preventDefault();
		let this_parent		= jQuery( this ).closest( '.autocomplete' );
		let has_results_box	= this_parent.find( '.autocomplete_results_box' ).hasClass( 'show_it' );

		if ( ! has_results_box ) {
			do_autocomplete( e, 'open', jQuery( this ) );
		}
	},
	focusout: function( e ) {
		e.preventDefault();
		do_autocomplete( e,'close', jQuery( this ) );
	}
}, the_doc );

// Autocomplete reset
the_doc.on( 'click', '.js_autocomplete_reset', function( e ) {
	e.preventDefault();
	do_autocomplete_reset( e, jQuery( this ) );
});

// Trigger autocomplete result
the_doc.on( 'click', '.js_autocomplete_result', function( e ) {
	e.preventDefault();
	do_autocomplete_result( e, jQuery( this ) );
});

// autocomplete search categories
jQuery('.js_search_categories_dropdown ').change(function () {
	let selected_categ_id = this.value;
	jQuery('.js_autocomplete ').attr('data-selected_category_id', selected_categ_id).trigger( 'keyup' );
})

// ----------------------------

// CSV Upload (cart - fast entry)
the_doc.on( 'change', '.js_upload_csv_cart', function( e ) {
	// e.preventDefault();
	let file_data = jQuery( '.js_upload_csv_cart' ).prop( 'files' )[0];
	let form_data = new FormData();
	// Fill form data
	form_data.append( 'file', file_data );
	// Process data and trigger modal or toast
	get_modal_articles( form_data );
});

// Toggle modal cell container (containing files list)
the_doc.on( 'click', '.js_modal_toggle_container', function( e ) {
	e.preventDefault();
	do_toggle_modal_container( e, jQuery( this ) );
});

// ----------------------------

// WATCH LIST

// Toggle add to watchlist - Heart icon
the_doc.on( 'click', '.js_show_watch_list', function( e ) {
	e.preventDefault();
	let _this		= jQuery( this );
	let this_parent	= _this.closest( '.watch_list_container' );
	let this_target	= this_parent.find( '.add_to_watchlist_wrapper' );
	let this_pid = _this.attr('data-pid');
	let list_add_new_div_flag = _this.attr('data-list_add_new_div_flag');
	let with_products = _this.attr('data-with_products');
	let extra_address_check_flag = _this.attr('data-extra_address_check_flag');

	// Close all other watchlist wrappers
	jQuery( '.add_to_watchlist_wrapper' ).removeClass( 'active' );
	jQuery( '.js_show_watch_list' ).nextAll().remove();

	// Show this watchlist wrapper
	this_parent.css( 'z-index', '3' );
	this_target.toggleClass( 'active' );

	//show the wrapper markup
	jQuery.ajax({
		type: 'post',
		url: ajax_url_global + Math.random(),
		data: {
			this_pid: this_pid,
			page: original_curr_page,
			list_add_new_div_flag: list_add_new_div_flag,
			extra_address_check_flag: extra_address_check_flag,
			with_products: with_products,
			ajax_action: 'shopping_list',
			function: 'show_watch_list_markup'
		},
		dataType: 'json',
		async: true,
		success: function(data) {
			_this.after(data);
		}
	});
});

// Toggle add to default watchlist - Heart icon
the_doc.on( 'click', '.js_default_watch_list', function( e ) {
	e.preventDefault();
	let _this		= jQuery( this );
	let this_parent	= _this.closest( '.watch_list_container' );
	let this_target	= this_parent.find( '.add_to_watchlist_wrapper' );
	let this_pid = _this.attr('data-pid');
	let list_add_new_div_flag = _this.attr('data-list_add_new_div_flag');
	let with_products = _this.attr('data-with_products');
	let extra_address_check_flag = _this.attr('data-extra_address_check_flag');

	// Close all other watchlist wrappers
	jQuery( '.add_to_watchlist_wrapper' ).removeClass( 'active' );
	// jQuery( '.js_default_watch_list' ).nextAll().remove();

	// Show this watchlist wrapper
	this_parent.css( 'z-index', '3' );
	this_target.toggleClass( 'active' );

	//show the wrapper markup
	jQuery.ajax({
		type: 'post',
		url: ajax_url_global + Math.random(),
		data: {
			this_pid: this_pid,
			ajax_action: 'shopping_list',
			function: 'default_watch_list'
		},
		dataType: 'json',
		async: true,
		success: function(data) {
			let this_target = this_parent.find( '.icon_heart' );
			let is_active = this_target.hasClass('active');
			let set_active = data.default_watch_list_product_toggle;

			let watchlist_count		= data.watchlist_count;
			let watchlist_counter   = jQuery( '.watchlist_count' );

			if ( set_active && !is_active ) {
				this_target.addClass( 'active' );
			} else if ( ! set_active && is_active ) {
				this_target.removeClass( 'active' );
			}
			// Found watch list items
			if ( watchlist_count > 0 ) {
				watchlist_counter.html( watchlist_count );
				// console.log( 'watchlist active' );
			} else {
				watchlist_counter.html( '0' );
			}

			_this.after(data);
		}
	});
});

// close watch_list_wrapper
the_doc.on( 'click', '.js_close_watch_list_wrapper', function( e ) {
	e.preventDefault();
	let _this			= jQuery( this );
	let this_wrapper	= _this.closest( '.watch_list_container' );
	let this_parent		= _this.parent();
	let this_prev		= this_parent.prev();
	this_wrapper.css( 'z-index', '0' );
	this_prev.nextAll().remove();
});

// Add to OR remove article from existing watchlist(s)
the_doc.on( 'click', '.js_existing_watch_list', function( e ) {
	// e.preventDefault();
	let _this			= jQuery( this );
	let this_parent		= _this.closest( '.watch_list_container' );
	let this_wrapper	= _this.closest( '.add_to_watchlist_wrapper' );
	let this_heart		= this_parent.find( '.icon_heart' );
	let this_id			= _this.data( 'id' );
	let this_pid		= _this.data( 'pid' );
	let target_input	= jQuery( '#input_' + this_pid );
	let quantity		= '';

	let func = 'delete_product';

	if ( target_input.val() ) {
		quantity = target_input.val();
	} else {
		quantity = 1;
	}

	// TODO: Check this because it's not removing the item after it has been added
	if ( _this.is( ':checked' ) ) {
		func = 'add_product_to_list';
	}

	jQuery.ajax({
		type: 'POST',
		url: ajax_url_global + Math.random(),
		data: {
			productID: this_pid,
			listID: this_id,
			quantity: quantity,
			ajax_action: 'shopping_list',
			function: func
		},
		async: true,
		dataType: 'json',
		success: function( data ) {
			// Show notification
			if ( func === 'add_product_to_list' ) {
				this_parent.find( '.icon_heart' ).addClass( 'active' );
				_this.prop( 'checked', true );
				this_parent.find( '.js_existing_watch_list[data-id="' + this_id + '"]' ).attr( 'checked', 'checked' );
			} else {
				if ( data.product_has_list === 0 ) {
					this_heart.removeClass( 'active' );
					_this.prop( 'checked', false );
					this_parent.find( '.js_existing_watch_list[data-id="' + this_id + '"]' ).attr( 'checked', '' );
				}
			}
		},
		complete: function() { },
		error: function() {
			console.log( 'Something went wong... hai!' );
		}
	});
});

// Toggle new watch list
the_doc.on( 'click', '.js_add_new_watch_list', function( e ) {
	let _this       = jQuery( this );
	let this_parent = _this.closest( '.add_to_watchlist_wrapper' );
	let this_icon	= _this.find( '.icon_toggle_new' );
	let this_target = this_parent.find( '.save_watch_list_wrapper' );

	this_icon.toggleClass( 'active' );
	this_target.toggle();
});

// Trigger save list when ENTER key has been pressed
the_doc.on( 'keypress', '.js_save_watch_list_input', function( e ) {
	// Key bindings
	let key = 'which' in e ? e.which : e.keyCode;

	let _this       = jQuery( this );
	let this_val	= _this.val();
	let this_parent = _this.closest( '.add_to_watchlist_wrapper' );
	let target		= this_parent.find( '.js_save_watch_list' );

	if ( key === 13 && this_val.length > 1 && _this.is( ':focus' ) ) {
		target.trigger( 'click' );
	}
});

// Create new watch list OR add cart to watch list
the_doc.on( 'click', '.js_save_watch_list', function( e ) {
	// e.preventDefault();
	let _this				= jQuery( this );
	let this_parent			= _this.closest( '.watch_list_container' );
	let toggle_wrapper		= this_parent.find( '.save_watch_list_wrapper' );
	let this_for_all_check	= this_parent.find( '.js_for_all_check' );
	let this_input			= this_parent.find( '.js_save_watch_list_input' );
	let this_val			= this_input.val();
	let toggle_icon			= this_parent.find( '.js_add_new_watch_list .icon_toggle_new' );
	let target_blocks		= jQuery( '.js_watch_list_listing' );
	let ajax_function		= 'save_as_list';

	if ( this_val.length > 1 ) {
		this_input.removeClass( 'input_error' ).focus();

		let with_products = this_input.data( 'with_products' );
		let that_pid = this_input.data( 'pid' );

		let for_all_checked = 0;

		if ( body_class( 'is_cart' ) ) {
			ajax_function = 'save_cart_as_list';
		}

		if ( this_for_all_check.is( ':checked' ) ) {
			for_all_checked = 1;
		}

		// Do some ajaxing
		jQuery.ajax({
			// cache: false,
			type: 'POST',
			url: ajax_url_global + Math.random(),
			data: {
				listName: this_val,
				with_products: with_products,
				pid: ( that_pid ? that_pid : null ),
				address_state: for_all_checked,
				ajax_action: 'shopping_list',
				function: ajax_function
			},
			async: true,
			dataType: 'json',
			success: function( data ) {
				this_input.val( '' );

				if ( body_class( 'is_list_products' ) || body_class( 'is_detail' ) ) {
					if ( data.watchlists[0] ) {
						let new_content = '';

						jQuery.each( data.watchlists, function( object ) {
							new_content += this.html;
						});

						target_blocks.html( new_content );
					}

					toggle_icon.toggleClass( 'active' );
					toggle_wrapper.toggle();
					this_parent.find( '.icon_heart' ).addClass( 'active' );

					this_for_all_check.prop( 'checked', false );
				} else if ( body_class( 'is_account_watch_list' ) ) {
					location.reload();
				} else if ( body_class( 'is_cart' ) ) {
					// When in cart
					this_parent.removeClass( 'active' );

					// Show add to watch list confirmation
					toast_title		= GLOB_SUCCESS;
					toast_content	= data.text_list_saved;
					toast_icon		= 'success';

					do_toast( toast_title, toast_content, toast_icon, 3000, '' );
				}
			},
			complete: function() {
				this_input.removeClass( 'input_error' );
				this_input.removeClass( 'input_correct' );
			},
			error: function() {
				console.log( 'Something went wong... hai!' );
			}
		});
	} else {
		this_input.addClass( 'input_error' ).focus();
	}
});

// ACCOUNT PAGE - WATCH LISTS

// Remove watch list completely
the_doc.on( 'click', '.js_remove_watch_list', function( e ) {
	// e.preventDefault();
	let _this       	= jQuery( this );
	let this_list_id	= _this.data( 'list_id' );

	Swal.fire({
		icon: 'warning',
		title: GLOB_WARNING,
		html: text_mssg_list,
		showDenyButton: true,
		confirmButtonText: BTN_CONTINUE,
		denyButtonText: BTN_CANCEL,
		showCloseButton: true
	}).then((result) => {
		if ( result.isConfirmed ) {
			gen_delete('', '', this_list_id, '', 'remove_shopping_list', '' );
		}
	})
});

// Remove single article from watch list
the_doc.on( 'click', '.js_remove_watch_list_article', function( e ) {
	// e.preventDefault();
	let _this      		= jQuery( this );
	let this_list_id	= _this.data( 'list_id' );
	let this_pos_id		= _this.data( 'pos_id' );

	Swal.fire({
		icon: 'warning',
		title: GLOB_WARNING,
		html: text_mssg_delete_from_list,
		showDenyButton: true,
		confirmButtonText: BTN_CONTINUE,
		denyButtonText: BTN_CANCEL,
		showCloseButton: true
	}).then((result) => {
		if ( result.isConfirmed ) {
			gen_delete( '', '', this_list_id, this_pos_id, 'remove_shopping_list_item', '' );
		}
	})
});


// Change address view state for list
the_doc.on( 'click', '.js_visible_for_all', function( e ) {
	// e.preventDefault();
	let _this   = jQuery( this );
	let this_id = _this.data( 'id' );

	Swal.fire({
		icon: 'warning',
		title: GLOB_WARNING,
		html: _this.data( 'tooltip' ) + '?',
		showDenyButton: true,
		confirmButtonText: BTN_CONTINUE,
		denyButtonText: BTN_CANCEL,
		showCloseButton: true
	}).then((result) => {
		if ( result.isConfirmed ) {
			jQuery.ajax({
				type: 'POST',
				url: ajax_url_global + Math.random(),
				data: {
					listID: this_id,
					ajax_action: 'shopping_list',
					function: 'edit_address_state'
				},
				async: true,
				dataType: 'json',
				success: function() { },
				complete: function() {
					location.reload();
				},
				error: function() {
					// When something went wrong
					console.log( 'Something went wong... Hai!' );
				}
			});
		}
	})
});

// Edit (stored) watch list name
the_doc.on( 'click', '.js_edit_watch_list_name', function( e ) {
	// e.preventDefault();
	let _this      	= jQuery( this );
	let this_target	= jQuery( '.js_edit_container' );

	this_target.toggle();
});

// Cancel editing watch list name
the_doc.on( 'click', '.js_edit_watch_list_cancel', function( e ) {
	// e.preventDefault();
	let _this      	= jQuery( this );
	let this_target	= jQuery( '.js_edit_container' );

	this_target.toggle();
});

// Save new watch list name
the_doc.on( 'click', '.js_save_watch_list_name', function( e ) {
	// e.preventDefault();
	let _this       = jQuery( this );
	let this_id		= _this.data( 'id' );
	let this_input	= jQuery( '.watch_list_name_input' );
	let this_val	= this_input.val();

	if ( this_val.length > 0 ) {
		// Trigger confirm mssg
		Swal.fire({
			icon: 'warning',
			title: GLOB_ATTENTION,
			html: WATCH_LIST_CHANGE_NAME,
			showDenyButton: true,
			confirmButtonText: BTN_CONTINUE,
			denyButtonText: BTN_CANCEL,
			showCloseButton: true
		}).then((result) => {
			if ( result.isConfirmed ) {
				new_list_name( this_id, this_val );
			}
		})
	} else {
		this_input.addClass( 'input_error' );
	}
});

// ----------------------------

// Responsive menu
// Show hamburger menu animation when showing responsive menu
the_doc.on( 'click', '.js_resp_menu_toggle', function( e ) {
	jQuery( '.js_menu_toggle_button' ).toggleClass( 'active' );
});

// ----------------------------

// LOPA PAGE
if ( body_class( 'is_lopa' ) ) {

	// When row is clicked
	the_doc.on( 'click', '.belege-clickable-row', function( e ) {
		let _this = jQuery( this );

		// We also need to check if the filter is active or not for the product rows inside the clicked row
		// let filterActive = jQuery('.backlog_filter').is(':checked');

		// If the clicked row is the one that was already opened, just close it and don't do any AJAX call
		if ( ! jQuery( e.target ).hasClass( 'download-belege' ) && ! jQuery( e.target ).hasClass( 'fa-file-export' ) ) {
			if ( _this.hasClass( 'belege-clickable-row-active' ) ) {
				_this.removeClass( 'belege-clickable-row-active' );
				jQuery( '.belege-info' ).remove();
			} else {
				let belegeID = _this.data( 'belege_id' );

				// If there is another table displayed, remove it
				if ( jQuery( '.belege-clickable-row-active' ).length > 0 ) {
					jQuery( '.belege-clickable-row-active' ).removeClass( 'belege-clickable-row-active' );
					jQuery( '.belege-info' ).remove();
				}

				jQuery.ajax({
					type: 'POST',
					url: ajax_url_global + Math.random(),
					data: {
						ajax_action: 'general_settings',
						function: 'get_products_from_belege',
						belegeID: belegeID
					},
					async: true,
					success: function( data ) {
						_this.addClass( 'belege-clickable-row-active' );
						_this.after( data.belegePositionen );

						// Trigger this special event after creating the new rows so the existing JS also affects them
						jQuery( '#lopa_page' ).trigger( 'newRows' );
					}
				});
			}
		}
	});

	// When load more is clicked
	the_doc.on( 'click', '#belege_load_more', function( e ) {
		let lastRow		= jQuery( '.belege-clickable-row:last' );
		let offset		= parseInt( jQuery( '#query_offset' ).val() );
		let newOffset	= offset + 20;

		jQuery( '#belege_load_more_wrapper' ).addClass( 'hide' );

		jQuery.ajax({
			type: 'POST',
			url: ajax_url_global + Math.random(),
			data: {
				ajax_action: 'general_settings',
				function: 'load_more_rows',
				offset: offset
			},
			async: true,
			success: function( data ) {
				if ( data.newRows != '' ) {
					lastRow.after( data.newRows );
					jQuery( '#query_offset' ).val( newOffset );
					jQuery( '.pagination > .left_space' ).html( data.pagination );
				}
				// If there are more elements to show in the table, show the "Load more" button
				if ( data.showmorebutton == 'true' ) {
					// If we change the filter and the button "Show more" was hidden
					// because there weren't anymore rows to show, then make it visible again
					if ( jQuery( '#belege_load_more_wrapper' ).hasClass( 'hide' ) ) {
						jQuery( '#belege_load_more_wrapper' ).removeClass( 'hide' );
					}
				}
			}
		});
	});

}

// ----------------------------

// Availability notification
the_doc.on( 'click', '.js_availability_notification', function( e ) {
	e.preventDefault();
	e.stopPropagation();
	let _this = jQuery( this );
	availability_notification( e, _this );
});

// ----------------------------

// Sorting orders
the_doc.on( 'change', '#js_select_orders_sort', function( e ) {
	jQuery( '.js_order_grouping' ).hide();
	let index = jQuery( this ).val();
	order_sort_items(index);
});

// Filter orders: Contains
// TODO: Create general filter function?
// Note: There is no need to specify case sensitivity as the ":contains" expression has already been extended to deal with this
the_doc.on( 'keyup', 'input[name="js_filter_orders"]', function( e ) {
	let key = 'which' in e ? e.which : e.keyCode;

	let this_elem	 	= jQuery( this );
	let this_val	 	= this_elem.val().toString().trim();
	let this_heading 	= jQuery( '.js_order_grouping' );
	let this_target	 	= jQuery( '.account_order_container' );
	let has_match		= this_target.filter( ':contains(' + this_val + ')' );
	let no_match	 	= jQuery( '.js_no_filtered_orders_found' );
	// Check for legit input
	if ( this_val.length >= 1 ) {
		this_target.hide();
		this_heading.hide();
		// Are there any matches?
		if ( has_match.length > 0 ) {
			has_match.show();
		} else {
			no_match.show();
		}
	} else if ( ! this_val.length ) {
		reset_orders_filter();
	}
	// If esc key is pressed
	if ( key === 27 ) {
		reset_orders_filter();
	}
});

// Filter orders: Date
the_doc.on( 'change', '#js_filter_orders_time_form', function( e ) {
	let selected_sort = jQuery('#js_select_orders_sort').find(":selected").val()
	jQuery('input[id="js_selected_orders_sort"]').val(selected_sort);
	jQuery( this ).submit();
});

// Toggle orders
the_doc.on( 'click', '.js_toggle_order', function( e ) {
	e.preventDefault();

	let _this = jQuery( this );
	let order_id = _this.attr( 'data-order-id' );
	let loaded = _this.attr( 'data-loaded' );
	let order_container_id = '#js_order_container_' +  order_id;

	jQuery( '[id^=js_order_container_]' ).not( order_container_id ).hide();

	if ( loaded !== '1' ) {
		jQuery.ajax({
			type: 'post',
			url: ajax_url_global + Math.random(),
			data: {
				order_id: order_id,
				ajax_action: 'general_settings',
				function: 'load_order_data'
			},
			async: true,
			dataType: 'json',
			success: function( data ) {
				jQuery( order_container_id ).html( data.order_detail);
				_this.attr( 'data-loaded', 1);
			},
			complete: function() {
				jQuery( order_container_id ).show();
				setTimeout(() => {
					set_select2();
				}, 250 );
			},
			error: function() {
				console.log( 'Something went wong... Hai!' );
			}
		});
	}else{
		jQuery( '#js_order_container_' +  order_id).toggle();
	}
});

// Toggle orders month
the_doc.on( 'click', '.js_toggle_orders_month', function( e ) {
	let _this						= jQuery( this );
	let orders_month_id				= _this.attr( 'data-order-month-id' );

	_this.toggleClass( 'active' );
	jQuery( '.js_orders_month_' +  orders_month_id ).toggle();
});

// ----------------------------

// FIX: Tabs slick slider wreck / (re-)init
the_doc.on( 'click', '.tab_link', function( e ) {
	// e.preventDefault();
	go_tab_link( jQuery( this ) );
});




// ----------------------------

// Checkout express events
the_doc.on( 'click', '.js_shipping_checkbox', function( e ) {
	let this_elem	= jQuery( this );
	let shipping_method = this_elem.val();
	let free_shipping = this_elem.attr( 'data-free-shipping' );
	let pass = this_elem.attr( 'data-pass' );
	let delivery_minimum_value = this_elem.attr( 'data-delivery-minimum-value' );

	jQuery.ajax({
		type: 'post',
		url: ajax_url_global + Math.random(),
		data: {
			shipping_method: shipping_method,
			free_shipping: free_shipping,
			pass: pass,
			delivery_minimum_value: delivery_minimum_value,
			ajax_action: 'express_checkout',
			function: 'change_shipping_method'
		},
		dataType: 'json',
		async: true,
		success: function(data) {
			jQuery('.js_update_order_total').html(data.order_total);
			jQuery('.js_payment_options').html(data.payment_options);
			if(Boolean(document.querySelector("script[src=\'https://www.paypalobjects.com/webstatic/ppplus/ppplus.min.js\']"))) {
				pp_event_content();
			}
			if(data.update_payment){
				jQuery('.js_payment_checkbox:checked').trigger('click');
			}
		}
	});
});
// ----------------------------
the_doc.on( 'click', '.js_payment_checkbox', function( e ) {
	let this_elem	= jQuery( this );
	let payment_method = this_elem.val();

	jQuery.ajax({
		type: 'post',
		url: ajax_url_global + Math.random(),
		data: {
			payment_method: payment_method,
			ajax_action: 'express_checkout',
			function: 'change_payment_method'
		},
		dataType: 'json',
		async: true,
		success: function(data) {
			jQuery('.js_update_order_total').html(data.order_total);
			jQuery('#js_checkout_process_button').html(data.process_button);
			jQuery('#checkout_confirmation').attr('action', data.form_action_url);
			if(Boolean(document.querySelector("script[src=\'https://www.paypalobjects.com/webstatic/ppplus/ppplus.min.js\']"))) {
				pp_event_content();
			}
		}
	});
});

// ----------------------------
the_doc.on( 'click', '.js_add_express_coupon', function( e ) {
	e.preventDefault();
	let coupon_code = jQuery('.js_express_coupon').val();
	process_coupon_express_checkout(coupon_code);

});

the_doc.on( 'click', '.js_remove_express_coupon', function( e ) {
	e.preventDefault();
	process_coupon_express_checkout('REMOVE');
});
// ----------------------------
// search filter functions

the_doc.on( 'click', '.js_category_search', function( e ) {
	e.preventDefault();
	populate_product_list( 'split_page_search', 1, jQuery( this ).attr( 'data-category-id' ) );
});

the_doc.on( 'click', '.js_remove_cat_filter', function( e ) {
	e.preventDefault();
	reset_search_categories();
});

// ----------------------------
// change delivery status
the_doc.on( 'click', '.js_change_delivery_status', function( e ) {
	let cart_container_line = jQuery( this ).parent().closest('.cart_container_line');
	cart_container_line.find('.js_quantity_input').trigger('focusout');
});

// ----------------------------

// Create account

// Toggle B2B / B2C
the_doc.on( 'click', '.js_toggle_account_type', function( e ) {
	e.preventDefault();
	toggle_account_type( e, jQuery( this ));
});

// ----------------------------


// Upload file

the_doc.on( 'change', '#js_file_upload', function (e) {
	e.preventDefault();
	let file_data 	= jQuery('#js_file_upload').prop('files')[0];
	let form_data 	= new FormData();
	form_data.append('image_file', file_data);
	jQuery.ajax({
		url: ajax_upload_b2b_url_global + Math.random(),
		dataType: 'text',  // <-- what to expect back from the PHP script, if anything
		cache: false,
		contentType: false,
		processData: false,
		data: form_data,
		type: 'post',
		success: function(response){
			let delete_btn  = jQuery('.js_delete_file');
			let ajax_response = JSON.parse(response);
			let target_input_txt    = jQuery( '[class*="js_upload_text"]' );
			if (ajax_response.response_code === 100) {
				jQuery( '#file_uploaded' ).val( ajax_response.name );
				jQuery( '.ajax_upload_response' ).removeClass('upload_mime_type_error');
				jQuery( '.ajax_upload_response' ).addClass('upload_success').html(ajax_response.response_text);
				delete_btn.addClass('active');
				// Set text for upload input
				target_input_txt.html(file_data['name']);
			}
			if (ajax_response.response_code === 415) {
				jQuery( '#file_uploaded' ).val( ajax_response.name );
				jQuery( '.ajax_upload_response' ).removeClass('upload_success');
				jQuery( '.ajax_upload_response' ).addClass('upload_mime_type_error').html(ajax_response.response_text);
				delete_btn.removeClass('active');
				// Remove text for upload input
				target_input_txt.html(ajax_response.reset_text);
			}
		}
	});
});

// delete uploaded file
the_doc.on( 'click', '.js_delete_file', function( e ) {
	e.preventDefault();
	let response_container = jQuery( '.ajax_upload_response' );
	let target_input_txt   = jQuery( '[class*="js_upload_text"]' );
	let filename    	   = jQuery( '#file_uploaded' ).val();
	let delete_btn  	   = jQuery('.js_delete_file');

	jQuery.ajax({
		type: 'post',
		url: ajax_url_global + Math.random(),
		data: {
			name: filename,
			ajax_action: 'general_settings',
			function: 'delete_uploaded_file'
		},
		dataType: 'json',
		async: true,
		success: function (data) {
			response_container.removeClass('upload_success');
			delete_btn.removeClass('active');
			response_container.html('');
			target_input_txt.html(data);
		}
	});
});



// ----------------------------

// LEGACY? Is it being used?

/*
// Put history in cart
the_doc.on( 'click', '.reorder_to_cart', function( e ) {
	e.preventDefault();

	let array_data	= [];
	let _this		= jQuery( this );
	let this_target = jQuery( 'input[id*="input_"]' );
	let total_items = 0;

	this_target.each( function() {
		let _that		= jQuery( this );
		let this_id		= _that.attr( 'data-id' );
		let this_watch_list_pos_id = _that.attr( 'data-watch_list_pos_id' );
		let this_amount	= Math.floor( parseFloat( _that.val() ));

		if ( this_amount > 0 ) {
			array_data.push({
				'watch_list_pos_id': this_watch_list_pos_id,
				'id': this_id,
				'amount': this_amount
			});

			total_items = Math.abs( total_items + this_amount );
		}
	});

	reorder( array_data, _this, total_items );

	this_target.each( function() {
		jQuery( this ).val( jQuery( this ).attr( 'data-products_quantity' ) );
	});

	let mssg = notify_list_1 + total_items + notify_list_2;
	notify( mssg );
});
*/

/*
// Smooth scrolling to in-page anchors
the_doc.on( 'click', 'a[href*=\\#]:not([href=\\#])', function() {
	if ( location.pathname.replace( /^\//,'' ) === this.pathname.replace( /^\//, '' ) && location.hostname === this.hostname ) {
		let body	= jQuery( 'html, body' );
		let target	= jQuery( this.hash );

		target = target.length ? target : jQuery( '[name=' + this.hash.slice( 1 ) + ']' );

		if ( target.length ) {
			body.animate({
				scrollTop: target.offset().top
			}, 500, 'swing' );

			return false;
		}
	}
});
*/

the_doc.on( 'click', '#callback', function( ) {
	let _this               = jQuery(this);
	let target_input        = jQuery( '#contactphone' );
	let target_container    = target_input.closest('.input_container');

	if ( _this.prop( 'checked' ) == true || _this.is( ':checked' ) ) {
		target_input.addClass('js_required');
		target_container.addClass('required');
	}  else {
		target_input.removeClass('js_required');
		target_container.removeClass('required');
	}
});

// notification center
the_doc.on( 'click', '#js_notification_setting_checkbox', function( e ) {
	e.preventDefault();
	e.stopPropagation();
	let _this = jQuery( this );
	toggle_notification_setting(_this);
});

the_doc.on( 'click', '.js_delete_notification', function( e ) {
	let _this = jQuery( this );
	let this_id		= _this.attr( 'data-pid' );
	Swal.fire({
		icon: 'warning',
		title: GLOB_WARNING,
		html: text_delete_notification,
		showDenyButton: true,
		confirmButtonText: BTN_CONTINUE,
		denyButtonText: BTN_CANCEL,
		showCloseButton: true
	}).then((result) => {
		if ( result.isConfirmed ) {
			gen_delete('', '', this_id, '', 'remove_notification', '' );
		}
	})
});

the_doc.on('change','.js_belege_selected_types', function( e ) {
	filter_belege_list();
});

the_doc.on('click','.js_attribute_product_select', function( e ) {
	change_product_by_attribute(jQuery( this ));
});


the_doc.on('click','#js_close_login_modal', function( e ) {
	close_login_modal();
});

jQuery('.autocomplete_results_box').on('mouseenter mouseleave', function(e) {
	e.preventDefault();
	jQuery('html').toggleClass('no_scroll');
});

the_doc.on( 'change', '.js_select_component_amount', function( e ) {
	let _this = jQuery( this );
	check_package_selected_items_amount(_this, false);
});

// Checkout page save dynamic properties via AJAX
jQuery( '.js_ajax_save_dynamic_property' ).change( function() {
	let field_value = jQuery(this).val();
	let this_element = jQuery(this);
	let field_name   = jQuery(this_element).attr('name');
	jQuery.ajax({
		type: 'post',
		url: ajax_url_global + Math.random(),
		data: {
			input_value: field_value,
			field_name: field_name,
			ajax_action: 'general_settings',
			function: 'save_dynamic_property'
		},
		async: true,
		success: function (data) {
			return true;
		}
	});
});